import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=57b22db6&scoped=true"
import script from "./forgot-password.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-password.vue?vue&type=script&setup=true&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=57b22db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b22db6",
  null
  
)

export default component.exports